import { IColumn } from "@fluentui/react";

export const getColumnWidth = (column: IColumn): number | "auto" => {
  return column.calculatedWidth ?? column.currentWidth ?? column.minWidth ?? "auto";
};
